export const DEFAULT_PIN_COLOR = '#000000';
export function getFeatureTokens(dt, feature) {
    switch (dt.themeVariant) {
        case 'high-contrast':
        case 'dark':
            if (feature.color === DEFAULT_PIN_COLOR) {
                return {
                    fg: dt.c.white,
                };
            }
        default:
            return {
                fg: feature.color,
            };
    }
}
